function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 19a7 7 0 100-14 7 7 0 000 14zm2.297-10.36l1.06 1.061L13.06 12l2.299 2.299-1.06 1.06-2.3-2.299-2.297 2.298-1.061-1.06L10.938 12 8.64 9.703l1.061-1.061 2.297 2.297 2.299-2.298z",
  fill: "currentColor"
});

function SvgTableClearIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgTableClearIcon;